import React, { useEffect, useState } from 'react';
import { Grid, Typography, TextField, Button, Select, MenuItem, Tooltip, CircularProgress } from '@mui/material'
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
// import Swal from "sweetalert2";
import appConfig from "../../config/appConfig";
import * as menuActions from '../../store/actions/breadcrumb';
import '../../style/common.css';
import * as Styled from '../../components/styled-components/Styled-Components';
import DeleteIcon from '@mui/icons-material/Delete';
import { useForm, Controller } from 'react-hook-form';
import * as businessUnitActions from '../../store/actions/businessUnit';
import { useLogout } from '../../components/Utils';
import { useTranslation } from 'react-i18next';

const ErrorStyle = {
    color: "red",
    display: 'flex',
    marginTop: '5px'
}
const textboxCss = {
    borderRadius: "3px",
    outline: "none",
    '&.MuiFormControl-root': {
        margin: "0"
    },
    '&.MuiTextField-root': {
        backgroundColor: '#fff'
    },
    '& .MuiInputBase-input': {
        backgroundColor: '#fff',
        fontSize: 16,
        fontFamily: appConfig.fontfamily,
        padding: "10px 14px",
        borderRadius: "3px",
        outline: "none",
        height: "35px",
        boxSizing: 'border-box',
        border: `1px solid ${appConfig.colors.secondaryBlue}`,
    },
    '& .MuiOutlinedInput-root': {
        padding: '0',
    }
};


const EditBusinessUnit = ({setBreadcrumb, getBusinessUnitDetails, businessUnitData, updateBusinessUnit, updatebusinessUnitData, getAllCountriesAndCurrency, countriesList}) => {
    const { t } = useTranslation('common');

    const params = useLocation();
    const { name } = useParams();
    const navigate = useNavigate();
    const [currenyMenuItem, setCurrenyMenuItem] = useState('');
    const [locationList, setLocationList] = useState([]);
    const [apiErr, setApiErr] = useState('');
    const [bunitData, setBunitData] = useState(null)
    const { register, handleSubmit, formState: { errors }, clearErrors, control, setValue, getValues } = useForm();
    const [deletedBUnitIds, setDeletedBUnitIds] = useState([]);
    const [locationError, setLocationError] = useState({locationNameErr: '', locationAddressErr: ''});
    const [isLoading, setIsLoading] = useState(false);
    const [countryList, setCountryList] = useState([]);
    const dispatch = useDispatch()
    const onLogout = useLogout();

    const handleChange = (e) => {
        setCurrenyMenuItem(e.target.value);
      };

    useEffect(() => {
        const subMenuData = {
            name: t("Business Units & Locations"),
            route: "/business-units",
            subRoutes: "edit-businessunit",
            subRoutesLabel: t("Edit"),
            isSubMenu: true
        }

        setBreadcrumb(subMenuData)
        getAllCountriesAndCurrency();
      }, []);
      useEffect(() => {
        getBusinessUnitDetails(name);
      },[]);
      useEffect(() => {
        if(countriesList && countriesList?.status === 200){
            setCountryList(countriesList?.data)
        } else if(countriesList && countriesList?.status === 401){ 
            onLogout();
        }
      }, [countriesList]);
      const onChangeInput = (e, property, id, index) => {
        setLocationList((prevLocationList) => {
          const updatedLocationList = prevLocationList?.map((location, currentIndex) => {
            if (currentIndex === index) {
              const newValue = e.target.value;
              location[property] = newValue;
              location[id]  = id;
              clearErrors(`${property}[${id}]`);
              setLocationError({})
            }
            return location;
          });
          return updatedLocationList;
        });
      };
      
      
    const handleAddClick = () => { 
        setLocationError({})
        const newRow = { id: `test-${new Date().getTime()}`, locationName: "", locationAddress: "", country: "", currency: ""};
        // const newRow = { id: `test-${new Date().getTime()}`, locationName: "", locationAddress: "", currency: ""};
        setLocationList(prevData => [...prevData, newRow]);
    };

    const handleFormSubmit = (data) => {
                if(!Object?.keys(errors)?.length){
            sendFormValues(data);
}
    }

    const sendFormValues = (inputData) => {
        const businessUnitName1 = inputData.businessName;
        const locationNames = inputData.locationName;
        const locationAddresses = inputData.locationAddress;
        const currencies = inputData.currency;
        const locationData = inputData.locations;
        const associatedLocations = locationList?.map((location, index) => ({
           
            locationName: location.locationName?.trim(),
            countryId: location.country ? location.country : location.countryId,
            address:  location?.locationAddress === "" ? "" : ( location.locationAddress?.trim() ||  location.address?.trim()),
            id: typeof location.id === "number" ? location.id : null ,
            currency: location.currency || "cad"
          }));
    
        const data = {
            businessUnitName: businessUnitName1?.trim(),
            businessLocation: associatedLocations,
            businessUnitId: bunitData?.businessUnitId,
            deletedBusinessLocation: deletedBUnitIds
        }
        
        if(locationList && locationList.length === 0) {
            setLocationError({
                locationAddressErr: '',
                // locationAddressErr: 'Please enter address.',
                locationNameErr: 'Please enter location.',
                countryErr: 'Please enter country.',
                // currencyErr: 'Please enter currency.',
            })
            setLocationList([{ id: `test-${new Date().getTime()}`, locationName: "", locationAddress: "", country: "", currency: ""}])
        } else {
            setIsLoading(true);
            setLocationError({})
            updateBusinessUnit(data)
        }
    }
    const handleRemoveClick = (idToRemove) => {
      if(typeof idToRemove  !== "number") {
        const testData = locationList.filter(row => row?.id !== idToRemove)
        setLocationList(testData);
      } else {
        const testData = locationList.filter(row => row?.id !== idToRemove)
        setLocationList(testData);
        
            const previousDeletedIds = [...deletedBUnitIds]
            let currentIds = []
            currentIds.push(idToRemove)
            setDeletedBUnitIds([...previousDeletedIds, ...currentIds]);
      }
    };

    useEffect(() => {
        if (businessUnitData?.businessUnitDetails && businessUnitData?.businessUnitDetails?.data && businessUnitData?.businessUnitDetails?.data?.status === 200 && businessUnitData?.businessUnitDetails?.data?.data?.businessUnitName === name) {
            setBunitData(businessUnitData?.businessUnitDetails?.data?.data);
            setValue("businessUnitName",businessUnitData?.businessUnitDetails?.data?.data?.businessUnitName)
            setLocationList(businessUnitData?.businessUnitDetails?.data?.data?.businessLocation || []);
        } else if (businessUnitData?.businessUnitDetails && businessUnitData?.businessUnitDetails?.status === 401) {
            onLogout();
        }
            else if (businessUnitData?.isError && !businessUnitData?.isLoading) {
        }
    }, [businessUnitData?.businessUnitDetails?.data?.data]);


    useEffect(() => {
        if(updatebusinessUnitData && updatebusinessUnitData.status === 200) {
            setIsLoading(false);
            navigate('/business-units');
            dispatch({
                type: "RESET_BUNIT",
                payload: null
            })
        }
        else if (updatebusinessUnitData && updatebusinessUnitData.status === 403){
            setIsLoading(false);
            setApiErr(updatebusinessUnitData.message)
        }
        else if (updatebusinessUnitData && updatebusinessUnitData.status === 401){
            setIsLoading(false);
            onLogout()
        }
    }, [updatebusinessUnitData]);

    const setCurrencyFunction = (data,property, id, index) => {
        const newObject = {
            target: {
                value : data?.currency
            }
        }
        onChangeInput(newObject, property, id, index)
    }

    return <div>
            <Grid container spacing={2}>
                <Grid item xs={6} sm={6} xl={6} lg={6} md={6}>
                    <h1 style={{ margin: 0, fontSize: "21px" }}><b>{t('Business Units & Locations')}</b></h1>
                </Grid>
            </Grid>
            <hr className='blue-border' style={{marginBottom: 35}}/>
            <form onSubmit={handleSubmit(handleFormSubmit)}>
                <Grid container spacing={2}>

                <Grid item md={12} xl={8} lg={8} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t('Business Unit Name')}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <TextField
                                {...register(`businessName`, { required: true, validate: value => value.trim() !== '' ||t('Please enter business unit name')})}                                
                                margin="normal"
                                id="businessName"
                                sx={textboxCss}
                                defaultValue={name}
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "businessName" }}
                            />
                            {(errors?.businessName?.type === "required" || errors.businessName?.type === "validate") && <span style={ErrorStyle}>{t('Please enter business unit name')}</span>}

                        </div>
                        {apiErr !== '' && (<span style={ErrorStyle}>{apiErr}</span>)}
                    </Grid>
                    <Grid item md={12} xl={8} lg={8} sm={12} xs={12}>
                        <Typography component="p" sx={{ color: appConfig.colors.black }} className='xxs-bold'>{t('Associated Locations')}  <span style={{color:"red"}}>{" *"}</span></Typography>
                    </Grid>
                    
                    <Grid container spacing={2} style={{width: '100%'}}>
                    <Grid item md={12} xl={8} lg={8} sm={12} xs={12}>
                    {locationList?.length !== 0 ? 
                    <Grid item container spacing={2} className="pl-0 m-0">
                          <Grid item xs={3} md={2}>
                            <Typography component="p" sx={{ color: appConfig.colors.black }} className='xxs-normal'>{t('Location')} </Typography>
                          </Grid>
                          <Grid item xs={9} md={5}>
                           <Typography component="p" sx={{ color: appConfig.colors.black }} className='xxs-normal'>{t('Address')} </Typography>
                          </Grid>
                          <Grid item xs={5} md={2}>
                           <Typography component="p" sx={{ color: appConfig.colors.black }} className='xxs-normal'>{t('Country')} </Typography>
                          </Grid>
                          <Grid item xs={5} md={2}>
                            <Typography component="p" sx={{ color: appConfig.colors.black }} className='xxs-normal'>{t('Currency')} </Typography>
                          </Grid>
                          <Grid item xs={2} md={1} style={{display: 'flex', gap: 10, justifyContent: 'end', padding: 0}}>
                          </Grid>
                        </Grid> : ''}
                    {locationList?.map((obj,index) => (
                        <Grid item container spacing={2} className="pl-0 m-0" key={obj.id}>
                          <Grid item xs={3} md={2}>
                          <input
                            {...register(`locations[${obj.id}].id`)}
                            type="hidden"
                            value={obj?.id}
                            />


                          <TextField
                                {...register(`locationName[${obj.id}]`, { required: true, validate: value => value.trim() !== '' || t("Please enter location")})}                                
                                margin="normal"
                                id={`locationName${obj.id}`}
                                sx={textboxCss}
                                defaultValue={obj?.locationName}
                                className='input-box'
                                fullWidth
                                onChange={(e) => onChangeInput(e, 'locationName', obj?.id, index)} 
                                inputProps={{ "aria-label": "location" }}
                            />
                            {(errors?.locationName?.[obj.id]?.type === "required" || errors?.locationName?.[obj.id]?.type === "validate") && <span style={ErrorStyle}>{t('Please enter location')}</span>}
                            {locationError?.locationNameErr !== "" && <span style={ErrorStyle}>{locationError?.locationNameErr}</span>}
                         </Grid>
                          <Grid item xs={9} md={5}>
                          <TextField
                                {...register(`locationAddress[${obj.id}]`, { required: false,})}                                
                                margin="normal"
                                id={`locationAddress[${obj.id}]`}
                                sx={textboxCss}
                                defaultValue={obj?.address}
                                className='input-box'
                                fullWidth
                                onChange={(e) => onChangeInput(e, 'locationAddress', obj?.id, index)} 
                                inputProps={{ "aria-label": "address" }}
                            />
                            {locationError?.locationAddressErr !== "" && <span style={ErrorStyle}>{locationError?.locationAddressErr}</span>}
                            {errors?.locationAddress?.[obj.id]?.type === "required" && <span style={ErrorStyle}>{t('Please enter address')}</span>}
                          </Grid>
                          <Grid item xs={5} md={2}>
                          <Controller
                            name={`country[${obj.id}]`}
                            control={control}
                            defaultValue={obj.country ? obj.country : obj.countryId}
                            rules={{ required: t('Please select an option') }}
                            render={({ field }) => (

                                <Select
                                {...field}
                                value={obj.country ? obj.country : obj.countryId } // Set the value from the form state
                                onChange={(e) => {
                                    field.onChange(e);
                                    onChangeInput(e, 'country', obj.id, index);
                                }}
                                className='normal-dropdown xxs-normal'
                                MenuProps={{
                                    style: { maxHeight: '300px' } // Set the desired max height here
                                }}
                                inputProps={{ 'aria-label': 'Without label' }}
                                >
                                {countryList && countryList?.map((item, i) => (
                                    <MenuItem key={i} className='xxs-normal filter-item' value={item.id} onClick={()=>{setCurrencyFunction(item,'currency', obj.id, index)}}>
                                    {item.countryName}
                                    </MenuItem>
                                ))}
                                </Select>
                            )}
                            />
                            {locationError?.countryErr !== "" && <span style={ErrorStyle}>{locationError?.countryErr}</span>}
                            {errors?.country?.[obj.id]?.type === "required" && (
                                <span style={ErrorStyle}>{t("Please select country")}</span>
                            )}
                          </Grid>
                          <Grid item xs={5} md={2}>
                          <Controller
                            name={`currency[${obj.id}]`}
                            control={control}
                            defaultValue={obj.currency}
                            // rules={{ required: 'Please select an option' }}
                            render={({ field }) => (
                                <Select
                                {...field}
                                value={obj.currency} // Set the value from the form state
                                disabled
                                sx={{textTransform: 'uppercase'}}
                                onChange={(e) => {
                                    field.onChange(e);
                                    onChangeInput(e, 'currency', obj.id, index);
                                }}
                                className='normal-dropdown xxs-normal'
                                inputProps={{ 'aria-label': 'Without label' }}
                                >
                                {countryList?.map((item, i) => (
                                    <MenuItem key={i} className='xxs-normal filter-item' value={item.currency} style={{textTransform:'uppercase'}} >
                                        {item.currency}
                                    </MenuItem>
                                    ))}
                                </Select>
                            )}
                            />
                            {/* {locationError?.currencyErr !== "" && <span style={ErrorStyle}>{locationError?.currencyErr}</span>} */}
                            {/* {errors?.currency?.[obj.id]?.type === "required" && <span style={ErrorStyle}>Please select currency.</span>} */}
                          </Grid>
                          <Grid item xs={2} md={1} style={{display: 'flex', gap: 10, justifyContent: 'end'}}>
                            {obj.isDeletable === false ? (
                                <Tooltip title={t("The business unit location cannot be deleted because it is linked to the charitable activities")} arrow placement="top" style={{position: 'relative', top: 3, cursor: 'pointer'}}>
                                <div className='action-icon' style={{cursor: 'default'}}>
                                    <DeleteIcon sx={{fontSize: 15, borderRadius:"50%", color:appConfig.colors.grayColor}} />
                                </div>
                           </Tooltip>
                            ) : 
                            <div onClick={()=> handleRemoveClick(obj.id)} className='action-icon'>
                                <DeleteIcon sx={{fontSize: 15, borderRadius:"50%", color:appConfig.colors.darkblue}} />
                            </div>
                           }
                               
                          </Grid>
                        </Grid>
                        ))}
                        <Button variant="outlined" style={{marginLeft: 16}} onClick={()=>{handleAddClick()}} className="add-field-btn">
                            {t("Add Location")}
                        </Button>   
                    </Grid>
                   
                </Grid>
                </Grid>
                <Grid container spacing={2}>
                <Grid item xs={12} sm={6} xl={4} lg={4} md={6}>
                    <Styled.PrimaryButton
                            type='submit'
                            variant="contained"
                            sx={{ mt: 3, fontFamily: appConfig.fontfamily, textTransform: 'capitalize', width: "100%", height: "51px" }}
                            color="primary"
                            className="xxs-bold"
                            disabled={isLoading}
                            // onClick={() => handleFormSubmit()}
                        >
                             {isLoading ? (<><CircularProgress className='progress-color' /><span style={{color:'#fff'}}>{t("Saving...")}</span></>) : <span>{t("Save")}</span>}
                        </Styled.PrimaryButton>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4} lg={4} md={6}>
                        <Styled.CancelButton
                            variant="outlined"
                            sx={{ mt: 3, fontFamily: appConfig.fontfamily, textTransform: 'capitalize', width: "100%", height: "51px" }}
                            color="primary"
                            className="xxs-bold"
                            onClick={() => navigate('/business-units')}
                        >
                            {t("Cancel")}
                        </Styled.CancelButton>
                    </Grid>
                    
                </Grid>
            </form>
    </div >
}

EditBusinessUnit.propTypes = {
    businessUnitData: PropTypes.arrayOf(PropTypes.array).isRequired,
    getBusinessUnitDetails: PropTypes.func.isRequired,
    setBreadcrumb: PropTypes.func.isRequired,
    getAllCountriesAndCurrency: PropTypes.func.isRequired,
}


const mapDispatchToProps = (dispatch) => {
    return {
        setBreadcrumb: (menu) => dispatch(menuActions.setSubmenu(menu)),
        getBusinessUnitDetails: (data) => dispatch(businessUnitActions.getBusinessUnitDetails(data)),
        updateBusinessUnit: (data) => dispatch(businessUnitActions.updateBusinessUnit(data)),
        getAllCountriesAndCurrency: (data) => dispatch(businessUnitActions.getAllCountriesAndCurrency(data))
    };
}
const mapStateToProps = (state) => ({ 
    businessUnitData: state.businessUnit,
    updatebusinessUnitData: state.businessUnit.updatebusinessUnitData,
    countriesList: state.businessUnit.countriesList
 })


export default connect(mapStateToProps, mapDispatchToProps)(EditBusinessUnit);